// @flow
import React from 'react'

const Avatar = (props: {avatarUrl: string}): React$Element<'div'> => (
  <div className='form__sidebar-left pull-left'>
    <div className='user-avatar-container'>
      <img className='avatar-normal' src={props.avatarUrl} alt='avatar' />
    </div>
  </div>
)

export default Avatar
window.Components.Avatar = React.createFactory(Avatar)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/Avatar.js